import React from 'react'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

export default function ({ currency, style }) {
    if (!currency) return null

    return (
        <span style={style}>
            <FormattedMessage
                id={`global.currency.${_.toUpper(currency)}`}
                defaultMessage={`{providedCurrency}`}
                values={{ providedCurrency: _.toUpper(currency) }}
            />
        </span>
    )
}
